import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BrandS, LabelL } from '@sorare/core/src/atoms/typography';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import collect from './assets/collect.webp';
import draw from './assets/draw.webp';
import pick from './assets/pick.webp';

const Wrapper = styled(Vertical)`
  padding: 0 var(--double-unit);
`;

const Steps = styled.div`
  & > * {
    flex: 1;
  }
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--double-unit);
  @media ${laptopAndAbove} {
    flex-direction: row;
  }
`;

const Img = styled.img`
  width: 100%;
  height: auto;
`;

const Step = styled(Vertical)`
  background: var(--c-nd-50);
  padding-top: var(--double-unit);
  border-radius: var(--unit);
`;
const StepTitle = styled(BodyL)`
  padding: 0 var(--double-unit);
  flex: 1;
`;
const StepNumber = styled(Vertical).attrs({ center: true })`
  width: var(--quadruple-unit);
  height: var(--quadruple-unit);
  border-radius: 50%;
  background: var(--c-nd-50);
`;

const messages = defineMessages({
  draw: {
    defaultMessage: 'Draw 10 cards for 1,000 Essence',
  },
  pick: {
    defaultMessage: 'Pick a card',
  },
  collect: {
    defaultMessage: 'Keep your card or return it for Essence',
  },
});

const STEPS = [
  {
    message: messages.draw,
    img: draw,
  },
  {
    message: messages.pick,
    img: pick,
  },
  {
    message: messages.collect,
    img: collect,
  },
];

export const HowItWorks = () => {
  return (
    <Wrapper center gap={3}>
      <Steps>
        {STEPS.map((step, index) => (
          <Step key={step.img} gap={1.5} center>
            <StepNumber>
              <BrandS>{index + 1}</BrandS>
            </StepNumber>
            <StepTitle bold className="text-center">
              <FormattedMessage {...step.message} />
            </StepTitle>
            <Img src={step.img} alt="" />
          </Step>
        ))}
      </Steps>
      <LabelL className="text-center" color="var(--c-nd-600)">
        <FormattedMessage defaultMessage="You have 10 minutes to pick a card — after that, one will be chosen for you!" />
      </LabelL>
    </Wrapper>
  );
};
